// extracted by mini-css-extract-plugin
module.exports = {"userInputContainer":"styles__userInputContainer--3SmQK","userInputHeader":"styles__userInputHeader--HX-WZ","userInput":"styles__userInput--1cj9C"};